import React, { Component } from 'react';
import { get, isNull, has } from "lodash"

import { withStepsState } from "./../../../shared/containers/containerStepsState"

import FirstTitle from '../../../shared/items/static/firstTitle';
import RadioCheckButton from '../../../shared/items/controls/radioCheckButton';
import ResultNextStepButton from "./resultNextStepButton"
import StepContentWrapper from "./../stepContentWrapper"
import StepControl from "./../stepControl"
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "./../../../shared/services/service.step"
import { sexData } from "./../sex/static.sexData"
import { resultData } from "./static.resultData"
import { steps } from "./../../../shared/static.steps"
import locales from "./../../../content.json"
import "./../../../shared/services/service.step.scss"

class Result extends Component {
  constructor() {
    super();

    this.state = {
      isOpenResult: false,
      itemsData: {}
    }
  }

  componentDidMount() {
    if (isCurrentStep(this.props.currentIndex, steps.result) && !this.state.isOpenResult)
      this.setState({ isOpenResult: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, data, onClearStep, onSetStepData } = this.props
    const { isOpenResult } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.result,
      isOpen: isOpenResult,
      handleChange: this.handleChangeOpen.bind(this),
    }

    if (isOpenResult && !has(data, ["result"]))
      onSetStepData("result")

    //clear value if change sex value param
    if (
      get(prevProps, ["data", "sex", "value"]) !== get(data, ["sex", "value"])
      && !isNull(get(data, ["sex", "value"]))
      && get(data, ["result", "isValid"], false)
    )
      onClearStep("result")

    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    const { data } = this.props
    const nextState = state === true
      ? {
        isOpenResult: state,
        itemsData: this.switchResultItems(get(data, ["sex", "value"], sexData.female.value)),
      }
      : {
        isOpenResult: state,
      }

    this.setState(nextState)
  }

  switchResultItems(value) {
    switch (value) {
      case sexData.male.value:
        return resultData.male;
      case sexData.female.value:
        return resultData.female;
      case sexData.other.value:
        return resultData.other;
    }
  }

  render() {
    const { currentIndex, data, onUpdateStepData } = this.props
    const { isOpenResult, itemsData } = this.state
    const params = {
      className: "wrapperResult",
      currentIndex: currentIndex,
      stepIndex: steps.result,
    }

    return isOpenResult ?
      <div className={buildStepClassName({ params })}>

        <StepContentWrapper>
          <FirstTitle>{locales[window.userLang].goal_ask}</FirstTitle>

          {
            Object.keys(itemsData).map((key, index) => {
              return (
                <RadioCheckButton
                  isChecked={get(data, ["result", "value"], null) === itemsData[key].value}
                  key={index}
                  onClick={() => {
                    if (get(data, ["result", "value"], null) !== itemsData[key].value) {
                      onUpdateStepData.bind(this, "result", "value", itemsData[key].value)();
                      onUpdateStepData.bind(this, "result", "title", itemsData[key].title)();
                      setTimeout(this.props.onToNextStep, 300);
                    }
                  }}
                  icon={itemsData[key].icon}
                >

                  <div>{itemsData[key].title}</div>

                </RadioCheckButton>
              )
            })
          }
        </StepContentWrapper>
      </div>
      : null
  }
}

export default withStepsState(Result);